<p-dialog
  header="Carga masiva de empleados"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="false"
  [style]="dialogStyle"
  [styleClass]="dialogStyleClass"
  (onHide)="closeDialog()"
>
  <div class="employee-bulk-load-container">
    <ng-container *ngIf="currentStep === 1">
      <div
        class="upload-zone"
        [class.drag-over]="isDragOver"
        (click)="openFileUpload()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <div class="upload-icon">
          <i class="pi pi-cloud-upload"></i>
        </div>
        <h3>Arrastra tus archivos aqui o haz clic para cargar</h3>
        <p>Formatos admitidos: .csv, .xlsx, .xls</p>
      </div>

      <div class="file-list completed" *ngIf="hasCompletedFile">
        <div class="file-item" *ngFor="let item of completedFiles">
          <div class="file-badge">
            {{ item.file.name.toLowerCase().endsWith('.csv') ? 'CSV' : 'XLS' }}
          </div>
          <div class="file-info">
            <strong>{{ item.file.name }}</strong>
            <span>{{ formatFileSize(item.file) }}</span>
          </div>
          <button type="button" class="remove-file" (click)="removeFile(item.index, $event)">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>

      <div class="upload-processing-separator" *ngIf="hasUploadingFile">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="file-list uploading" *ngIf="hasUploadingFile">
        <div class="file-item is-uploading" *ngFor="let item of uploadingFiles">
          <div class="file-badge">
            {{ item.file.name.toLowerCase().endsWith('.csv') ? 'CSV' : 'XLS' }}
          </div>
          <div class="file-info">
            <strong>{{ item.file.name }}</strong>
            <span>{{ getUploadProgress(item.index) }}% de {{ formatFileSize(item.file) }}</span>
            <div class="progress-track">
              <div
                class="progress-line"
                [style.width.%]="getUploadProgress(item.index)"
              ></div>
            </div>
          </div>
          <button type="button" class="remove-file" (click)="removeFile(item.index, $event)">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <p-fileUpload
        #excelUploader
        [multiple]="true"
        [accept]="'.csv,.xlsx,.xls'"
        (onSelect)="onChangeFile($event)"
        [style]="{ display: 'none' }"
      ></p-fileUpload>
    </ng-container>

    <ng-container *ngIf="currentStep === 2">
      <div #bulkTableAnchor>
        <app-page-container
          [contentContainerClass]="'employee-bulk-table'"
          [displayedColumns]="displayedColumns"
          [dataSource]="dataSource"
          [showPreviewCard]="false"
          [isLoading]="isLoading"
          [useServerPagination]="true"
          [paginationLength]="totalElements"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [hasCheckbox]="false"
          (pageChange)="onPageChange($event)"
          [customTemplates]="{
            status: statusTemplate,
            messages: messagesTemplate,
            remove: removeTemplate,
            'employee.startDate': startDateTemplate,
            'contract.totalSalary': salaryTemplate
          }"
        >
          <ng-template #statusTemplate let-row>
            <span [ngClass]="['status-pill', row.status?.toLowerCase()]">
              {{ row.status }}
            </span>
          </ng-template>

          <ng-template #messagesTemplate let-row>
            <button
              type="button"
              class="observation-action"
              [disabled]="!hasRowMessages(row)"
              (click)="openObservationsModal(row, $event)"
            >
              <i class="pi pi-eye"></i>
              <span>Ver</span>
            </button>
          </ng-template>

          <ng-template #removeTemplate let-row>
            <button
              type="button"
              class="remove-row-action"
              [disabled]="isLoading || removingRowId === row.rowId"
              (click)="removePreviewRow(row, $event)"
            >
              <i class="pi pi-trash"></i>
            </button>
          </ng-template>

          <ng-template #startDateTemplate let-row>
            {{ formatDate(row.employee?.startDate) }}
          </ng-template>

          <ng-template #salaryTemplate let-row>
            {{ formatCurrency(row.contract?.totalSalary) }}
          </ng-template>
        </app-page-container>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="bulk-footer">
      <div class="bulk-footer-actions">
        <button type="button" pButton class="btn btn-default" (click)="backStep()">
        {{ currentStep === 1 ? 'Cancelar' : 'Atras' }}
        </button>
        <button
          type="button"
          pButton
          class="btn btn-solid"
          (click)="nextStep()"
          [disabled]="currentStep === 1 ? !isFileReady : hasInvalidRows"
        >
          {{ nextButtonLabel }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Observaciones"
  [(visible)]="showObservationsModal"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="false"
  [style]="{ width: '420px', maxWidth: '92vw' }"
  styleClass="bulk-observations-dialog"
>
  <p class="observations-context" *ngIf="selectedObservationContext">
    {{ selectedObservationContext }}
  </p>

  <ul class="observations-list" *ngIf="selectedObservationMessages.length > 0">
    <li *ngFor="let message of selectedObservationMessages">
      {{ message }}
    </li>
  </ul>

  <p class="observations-empty" *ngIf="selectedObservationMessages.length === 0">
    Sin observaciones.
  </p>
</p-dialog>
